const DEFAULT_BASE_PATH = "/buypanels";
const SUPPORTED_BASE_PATHS = new Set([
  "buypanels",
  "buysolar",
  "virtualbatteryincluded",
  "evsolar",
  "corporatesolar",
]);

export function getBuyPanelsBasePath(pathname: string = window.location.pathname) {
  const [base] = pathname.split("/").filter(Boolean);
  if (base && SUPPORTED_BASE_PATHS.has(base)) {
    return `/${base}`;
  }

  return DEFAULT_BASE_PATH;
}

export function getBuyPanelsRootSlug(pathname: string = window.location.pathname) {
  return getBuyPanelsBasePath(pathname).slice(1);
}

export function getBuyPanelsPath(
  pathname: string | undefined,
  suffix: string
) {
  const basePath = getBuyPanelsBasePath(pathname ?? window.location.pathname);
  const normalizedSuffix = suffix.replace(/^\//, "");

  if (!normalizedSuffix) {
    return basePath;
  }

  return `${basePath}/${normalizedSuffix}`;
}

export function isVirtualBatteryIncludedPath(
  pathname: string = window.location.pathname
) {
  return getBuyPanelsRootSlug(pathname) === "virtualbatteryincluded";
}

export function isBuySolarPath(
  pathname: string = window.location.pathname
) {
  return getBuyPanelsRootSlug(pathname) === "buysolar";
}

export function isCorporateSolarPath(
  pathname: string = window.location.pathname
) {
  return getBuyPanelsRootSlug(pathname) === "corporatesolar";
}

